import { resetMailSession } from '@/stores/mailSession'
import { resetSpaceSession } from '@/stores/space'
import { useMyWeekStore } from '@/stores/myWeek'
import { useTimerStore } from '@/stores/timer'
import { useTaskStore } from '@/stores/task'
import { useProtocolStore } from '@/stores/protocol'
import { useContactImportStore } from '@/stores/contactImport'
import { useAccountSettingsStore } from '@/stores/accountSettings'
import { useUsersStore } from '@/stores/users'

/**
 * Ends the per-session state of the stores that hold data of one user in one account. Called on
 * logout (stores/auth.ts) and on a REAL account switch (utils/account-manager.js: another account
 * or another user), never on the hourly signature refresh of the same account. The next session
 * in the same tab must not see the previous one's mail state, spaces, week, running timer, list
 * filters, contact import run (its polling is stopped) or account logo, nor receive answers its
 * requests still had in flight.
 */
export function resetSessionStores(): void {
  resetMailSession()
  resetSpaceSession()
  useMyWeekStore().resetState()
  useTimerStore().resetState()
  useTaskStore().$reset()
  useProtocolStore().$reset()
  const contactImport = useContactImportStore()
  contactImport.stopPolling()
  contactImport.$reset()
  useAccountSettingsStore().resetState()
  // The user cache holds the members of the previous account.
  useUsersStore().resetState()
}

/**
 * Loads what App.vue only loads on mount, for the new session after a real account switch (no
 * reload, no login view in between): the account's users (pickers, names) and its logo.
 */
export function reloadSessionData(): void {
  useUsersStore().getUserList().catch(() => undefined)
  useAccountSettingsStore().getAccountSettings().catch(() => undefined)
}
